module.exports = ".error {\n  color: #e60000;\n  font-size: 0.5833rem;\n  margin: 0; }\n\n.icon {\n  display: inline-block;\n  float: none; }\n\n.hint-section {\n  position: relative;\n  text-align: center;\n  height: 24px; }\n\n.hint-section p {\n    position: absolute;\n    left: 0;\n    right: 0; }\n\n.confirm-text {\n  padding: 25px 45px 15px 45px;\n  text-align: center;\n  color: #9e9e9e; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/patient-additional-details-modal/patient-additional-details-modal.component.scss
// module id = ./src/app/shared/components/patient-additional-details-modal/patient-additional-details-modal.component.scss
// module chunks = main